import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

import { PASSWORD_RULES } from '../../utils/password-rules';

type StrengthLevel = 'weak' | 'medium' | 'strong';

const STRENGTH_LABELS: Record<StrengthLevel, string> = {
  weak: 'Fraca',
  medium: 'Média',
  strong: 'Forte'
};

@Component({
  standalone: true,
  selector: 'app-password-rules',
  templateUrl: 'password-rules.component.html',
  styleUrl: 'password-rules.component.scss',
  imports: [CommonModule, MatIconModule]
})
export class PasswordRulesComponent {
  @Input() value: string | null | undefined = '';
  // Mostra o resultado real (✓/✗) quando o campo foi focado ou já tem valor; antes disso as regras ficam neutras.
  @Input() active = false;

  readonly rules = PASSWORD_RULES;

  get pristine(): boolean {
    return !this.value;
  }

  get showResult(): boolean {
    return this.active || !this.pristine;
  }

  get metCount(): number {
    return this.rules.filter(rule => this.isMet(rule.test)).length;
  }

  get percent(): number {
    return (this.metCount / this.rules.length) * 100;
  }

  // Só informativo: não bloqueia o envio, quem bloqueia é o strongPasswordValidator.
  get level(): StrengthLevel {
    if (this.metCount === this.rules.length) return 'strong';
    return this.metCount >= 3 ? 'medium' : 'weak';
  }

  get levelLabel(): string {
    return this.pristine ? '' : STRENGTH_LABELS[this.level];
  }

  isMet(test: (value: string) => boolean): boolean {
    return !this.pristine && test(this.value as string);
  }

  isUnmet(test: (value: string) => boolean): boolean {
    return this.showResult && !this.isMet(test);
  }

  icon(test: (value: string) => boolean): string {
    if (this.isMet(test)) return 'check_circle';
    return this.isUnmet(test) ? 'cancel' : 'radio_button_unchecked';
  }
}
